import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";

import { mediumCategoryColors, mediumPillarColors, PillarSlug } from "../../../../thematics/colors";
import { CreateTrainService } from "../../../../thematics/create-train.service";
import { Thematic } from "../../../../thematics/models/thematic.model";
import { Train } from "../../../../trains/models/train.entity";
import { Sherpa } from "../../../../users/models/sherpa.entity";
import { CreditCheckService } from '../../../services/credit-check.service';
import { formatDate, formatTimeSlot } from "../../../tool-functions/date-tools";

type TrainByThematic = { thematic: Thematic, trains: Train[] };

@Component({
  selector: 'app-thematic-trains',
  templateUrl: './thematic-trains.component.html',
  styleUrls: [ './thematic-trains.component.scss' ]
})
export class ThematicTrainsComponent implements OnInit, OnDestroy {

  @Input() trainsByThematics!: TrainByThematic;

  colorMedium!: string;

  destroys$ = new Subject<void>();

  constructor(
              private readonly router: Router,
              private readonly route: ActivatedRoute,
              private readonly creatTrainService: CreateTrainService,
              private readonly creditCheckService: CreditCheckService,
            ) {
  }

  ngOnInit() {
    const thematic = this.trainsByThematics.thematic;
    const pillarName = thematic.pillar?.name as PillarSlug;
    const categorySlug = thematic.category?.slug;

    this.colorMedium = categorySlug
      ? mediumCategoryColors[categorySlug]
      : (pillarName ? mediumPillarColors[pillarName] : '');
  }

  ngOnDestroy() {
    this.destroys$.next();
  }

  dateFormat = formatDate;

  timeFormat = formatTimeSlot;

  goToSherpa(sherpa: Sherpa): void {
    this.router.navigate([ 'sherpas', sherpa.id ]);
  }

  goToThematic(): void {
    this.router.navigate([ 'thematics', this.trainsByThematics.thematic.slug ]);
  }

  selectTrain(train: Train) {
    const isThematicPage = window.location.pathname.includes('thematics');
    (window._mtm || []).push({ 'event':  isThematicPage ? 'inscription-parcours-thematique' : 'inscription-parcours', 'nom-parcours': train.dynamic.thematic.title });

    this.creditCheckService.checkAndNotify(
      train.dynamic.type, 
      () => this.creatTrainService.selectTrain(train)
    );
  }

  goToCreateTrain(): void {
    (window._mtm || []).push({ 'event': 'nouvel-horaire-parcours', 'nom-parcours': this.trainsByThematics.thematic.title });
    this.creatTrainService.clearTrain();
    this.creatTrainService.selectThematic(this.trainsByThematics.thematic);
  }
}
